import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/auth/password/change`

const changePassword = (data: {
  newPassword: string
  token: string
  captcha: string
}): AxiosPromise => apiFetch(URL, { data, method: `PUT` })

export default changePassword
